module.exports = __webpack_public_path__ + "static/featured-study-a9868d9e01415072481fdeb3983be640.jpg";